<template>
    <a-tooltip placement="topLeft" :title="status.msg">
        <div :class="status.class"></div>
    </a-tooltip>
</template>

<script>
import { ERROR_CODE } from '../constant';
export default {
    props: [ 'verify' ],
    computed: {
        status() {
            if (this.verify == -1) {
                return { class: 'iok', msg: '录像验证成功！' };
            } else if (this.verify == 0 || this.verify == 8) {
                return { class: 'iunknown', msg: '录像未验证（匿名提交或塔版本过低）' };
            } else {
                return {
                    class: 'ierror',
                    msg: `录像验证失败，错误代码：${ this.verify }\n可能原因：${ ERROR_CODE[this.verify] || '未知' }`
                };
            }
        }
    },
    methods: {
        showInfo() {
            this.$info({
                content: h => (<span class="message">{ this.status.msg }</span>),
            });
        }
    }
}
</script>

<style lang="less" scoped>
.iok {
    background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'%3E%3Cpath d='M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-2-5.8l-2.6-2.6L6 13l4 4 8-8-1.4-1.4z' fill='green'/%3E%3C/svg%3E") no-repeat center;
}
.ierror {
    background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'%3E%3Cpath d='M14.59 8L12 10.59 9.41 8 8 9.41 10.59 12 8 14.59 9.41 16 12 13.41 14.59 16 16 14.59 13.41 12 16 9.41zM12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z' fill='red'/%3E%3C/svg%3E") no-repeat center;
}
.iunknown {
    background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'%3E%3Cpath d='M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z' fill='blue'/%3E%3C/svg%3E") no-repeat center;
}
.iok, .ierror, .iunknown {
    background-size: 100%;
    width: 20px;
    height: 20px;
    cursor: pointer;
}
</style>